import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteEntityDocument } from './documents.service'

export const useEntityDocumentDelete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteEntityDocument,
    onSuccess: async (_, vars) => {
      await queryClient.invalidateQueries({
        queryKey: ['entityDocuments', vars.entityId],
      })
    },
  })
}
